import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";
import Scrolltotop from "./components/ScrollToTop/ScrollToTop"

import MainRoutes from "./Routes"

const App = () => {
  return (
    <BrowserRouter>
     <Scrolltotop />
      <MainRoutes />

      <ToastContainer theme="colored" />
    </BrowserRouter>
  );
};

export default App;